module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__bottom__buttons__a--call-end-079086e69c14bc65c0175b9ecfc08e25.svg";